import React, { useState, useEffect } from 'react';
import api, { formatMoney } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const UNITS = ['کیلوگرام', 'گرام', 'لیتر', 'بسته', 'عدد', 'کارتن', 'تن'];
const CATS = ['آرد', 'برنج', 'روغن', 'قند و شکر', 'حبوبات', 'مواد خشک', 'سایر'];

export default function Products() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(false);
  const [stockModal, setStockModal] = useState(null);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', category: '', unit: 'کیلوگرام', price_buy: '', price_sell: '', stock: '', min_stock: '' });
  const [stockForm, setStockForm] = useState({ type: 'in', quantity: '', price_per_unit: '', note: '' });
  const [msg, setMsg] = useState('');
  const { isAdmin } = useAuth();

  const load = async () => { const { data } = await api.get('/products'); setProducts(data); };
  useEffect(() => { load(); }, []);

  const openAdd = () => { setEditing(null); setForm({ name: '', category: '', unit: 'کیلوگرام', price_buy: '', price_sell: '', stock: '0', min_stock: '0' }); setModal(true); };
  const openEdit = (p) => { setEditing(p); setForm({ name: p.name, category: p.category || '', unit: p.unit, price_buy: p.price_buy, price_sell: p.price_sell, stock: p.stock, min_stock: p.min_stock }); setModal(true); };

  const handleSave = async () => {
    try {
      if (editing) await api.put(`/products/${editing.id}`, form);
      else await api.post('/products', form);
      setModal(false); setMsg(''); load();
    } catch (err) { setMsg(err.response?.data?.message || 'خطا'); }
  };

  const handleStock = async () => {
    try {
      await api.post(`/products/${stockModal.id}/stock`, stockForm);
      setStockModal(null);
      setStockForm({ type: 'in', quantity: '', price_per_unit: '', note: '' });
      load();
    } catch (err) { alert(err.response?.data?.message || 'خطا'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('حذف شود؟')) return;
    await api.delete(`/products/${id}`); load();
  };

  const filtered = products.filter(p => p.name.toLowerCase().includes(search.toLowerCase()) || (p.category || '').includes(search));

  return (
    <div>
      <div className="page-header">
        <h1>مدیریت انبار</h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <input className="search-input" placeholder="🔍 جستجو..." value={search} onChange={e => setSearch(e.target.value)} />
          <button className="btn btn-primary" onClick={openAdd}>➕ محصول جدید</button>
        </div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>#</th><th>نام محصول</th><th>دسته</th><th>واحد</th><th>قیمت خرید</th><th>قیمت فروش</th><th>موجودی</th><th>وضعیت</th><th>عملیات</th></tr>
            </thead>
            <tbody>
              {filtered.map((p, i) => {
                const low = Number(p.stock) <= Number(p.min_stock);
                return (
                  <tr key={p.id}>
                    <td style={{ color: 'var(--text-muted)' }}>{i + 1}</td>
                    <td style={{ fontWeight: 500 }}>{p.name}</td>
                    <td><span className="badge badge-info">{p.category || '—'}</span></td>
                    <td>{p.unit}</td>
                    <td>{formatMoney(p.price_buy)}</td>
                    <td style={{ fontWeight: 500, color: 'var(--success)' }}>{formatMoney(p.price_sell)}</td>
                    <td style={{ fontWeight: 600, color: low ? 'var(--danger)' : 'var(--text)' }}>
                      {Number(p.stock).toLocaleString('fa')} {p.unit}
                    </td>
                    <td>
                      {low
                        ? <span className="badge badge-danger">⚠️ کم موجودی</span>
                        : <span className="badge badge-success">✓ کافی</span>}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-success btn-sm" onClick={() => { setStockModal(p); setStockForm({ type: 'in', quantity: '', price_per_unit: p.price_buy, note: '' }); }}>📥 انبار</button>
                        <button className="btn btn-outline btn-sm" onClick={() => openEdit(p)}>✏️</button>
                        {isAdmin && <button className="btn btn-danger btn-sm" onClick={() => handleDelete(p.id)}>🗑️</button>}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && <tr><td colSpan={9} style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>محصولی یافت نشد</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal افزودن/ویرایش محصول */}
      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <span className="modal-title">{editing ? 'ویرایش محصول' : 'محصول جدید'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            {msg && <div className="alert alert-danger">{msg}</div>}
            <div className="form-group">
              <label className="form-label">نام محصول *</label>
              <input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">دسته‌بندی</label>
                <select className="form-control" value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
                  <option value="">انتخاب کنید</option>
                  {CATS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">واحد *</label>
                <select className="form-control" value={form.unit} onChange={e => setForm({ ...form, unit: e.target.value })}>
                  {UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">قیمت خرید (افغانی)</label>
                <input className="form-control" type="number" value={form.price_buy} onChange={e => setForm({ ...form, price_buy: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">قیمت فروش (افغانی)</label>
                <input className="form-control" type="number" value={form.price_sell} onChange={e => setForm({ ...form, price_sell: e.target.value })} />
              </div>
              {!editing && (
                <div className="form-group">
                  <label className="form-label">موجودی اولیه</label>
                  <input className="form-control" type="number" value={form.stock} onChange={e => setForm({ ...form, stock: e.target.value })} />
                </div>
              )}
              <div className="form-group">
                <label className="form-label">حداقل موجودی (هشدار)</label>
                <input className="form-control" type="number" value={form.min_stock} onChange={e => setForm({ ...form, min_stock: e.target.value })} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setModal(false)}>انصراف</button>
              <button className="btn btn-primary" onClick={handleSave}>💾 ذخیره</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal ورود/خروج انبار */}
      {stockModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setStockModal(null)}>
          <div className="modal">
            <div className="modal-header">
              <span className="modal-title">📦 {stockModal.name} — ثبت انبار</span>
              <button className="modal-close" onClick={() => setStockModal(null)}>×</button>
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
              {['in', 'out'].map(t => (
                <button key={t} className={`btn ${stockForm.type === t ? 'btn-primary' : 'btn-outline'}`}
                  style={{ flex: 1 }} onClick={() => setStockForm({ ...stockForm, type: t })}>
                  {t === 'in' ? '📥 ورود به انبار' : '📤 خروج از انبار'}
                </button>
              ))}
            </div>
            <div style={{ background: 'var(--bg)', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 13 }}>
              موجودی فعلی: <strong>{Number(stockModal.stock).toLocaleString('fa')} {stockModal.unit}</strong>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">مقدار ({stockModal.unit}) *</label>
                <input className="form-control" type="number" value={stockForm.quantity} onChange={e => setStockForm({ ...stockForm, quantity: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">قیمت فی واحد (افغانی)</label>
                <input className="form-control" type="number" value={stockForm.price_per_unit} onChange={e => setStockForm({ ...stockForm, price_per_unit: e.target.value })} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">یادداشت</label>
              <input className="form-control" value={stockForm.note} onChange={e => setStockForm({ ...stockForm, note: e.target.value })} placeholder="مثلاً: خریداری از بازار..." />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setStockModal(null)}>انصراف</button>
              <button className="btn btn-primary" onClick={handleStock}>✅ ثبت</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
